import React, {useState} from "react";
import "./style.css";
import mobileF from "Assets/Images/footer/footermobile.png";
import bazar from "Assets/Images/Hero2/bazar.png";

import anardooni from "Assets/Images/Hero2/anardooni.png";
import Google_Play from "Assets/Images/Hero2/Google_Play.png";
import myket from "Assets/Images/Hero2/myket.png";
import sibapp from "Assets/Images/Hero2/sibapp.png";
import sibche from "Assets/Images/Hero2/sibche.jpg";
import Iapps from "Assets/Images/Hero2/iapps.png";
import sibirani from "Assets/Images/Hero2/sibirani.png";
import webapp from "Assets/Images/Hero2/webapp.png";
import logo from "Assets/Images/Logo/logoRes2.png";
import dapapptext from "Assets/Images/Logo/dapapptext.png";
import namad1 from "Assets/Images/footer/namad1.png";
import namad2 from "Assets/Images/footer/namad2.png";
import namad3 from "Assets/Images/footer/namad3.png";
import {GeoAlt, Telephone, X} from "react-bootstrap-icons";
import {Link} from "react-router-dom";
import {Modal} from "react-bootstrap";

import ecunionIcon from "Assets/Images/TrustDaapapp/ecunion.png";
import ecunionImg from "Assets/Images/TrustDaapapp/ecunionImg.jpg";

const FooterB = () => {
    const [ecunion, setEcunion] = useState(false);
    const onLinkLink = (link) => {
        window.open(link, "_blank", "noopener");
    };

    return (
        <>
            <div className="all-footer-b">
                <div className="footer-b-first container border-bottom border-gray py-5 ">
                    <div className="about-box ">
                        <div className="each-about-box footer-b-links">
                            <ul className="m-0 d-flex flex-column justify-content-between ">
                                <Link to="/about" className="py-1 m-0 mx-0 main-color">
                                    درباره ما
                                </Link>
                                <Link to="/about" className="py-1 m-0 mx-0 main-color">
                                    تماس با ما
                                </Link>
                            </ul>
                        </div>
                        {/* 2 */}
                        <div className="each-about-box footer-b-links">
                            <ul className="m-0 d-flex flex-column  align-items-start">
                                <button
                                    onClick={() => onLinkLink("https://landing.daapapp.com/7/")}
                                    className=" border-0 bg-shiri"
                                >
                                    <li className="py-1">نصب</li>
                                </button>
                                <button
                                    onClick={() => onLinkLink("https://landing.daapapp.com/8/")}
                                    className=" border-0 bg-shiri"
                                >
                                    <li className="py-1">کار با اپلیکیشن</li>
                                    {" "}
                                </button>
                                <button
                                    onClick={() => onLinkLink("https://landing.daapapp.com/9/")}
                                    className=" border-0 bg-shiri"
                                >
                                    <li className="py-1 "> مزایای داپ اَپ</li>
                                </button>
                            </ul>
                        </div>
                        {/* 3 */}
                        <div className="each-about-box footer-b-links">
                            <ul className="m-0 d-flex flex-column  align-items-start">
                                <button
                                    onClick={() => onLinkLink("https://landing.daapapp.com/12/")}
                                    className=" border-0 bg-shiri"
                                >
                                    <li className="py-1"> امکانات کیف پول و برداشت</li>
                                </button>
                                <button
                                    onClick={() => onLinkLink("https://landing.daapapp.com/11/")}
                                    className=" border-0 bg-shiri"
                                >
                                    <li className="py-1">پیدا کردن فروشگاه</li>
                                </button>
                                <button
                                    onClick={() => onLinkLink("https://landing.daapapp.com/10/")}
                                    className=" border-0 bg-shiri"
                                >
                                    <li className="py-1">ثبت کارت</li>
                                </button>
                            </ul>
                        </div>
                    </div>
                    {/* download link */}
                    <div className="link-app-footer">
                        <img
                            src={mobileF}
                            loading="lazy"
                            alt=""
                            className="mobile-footer-b"
                        />
                        <div className="box-app-links-footer me-2">
                            <div className="up-link-app-footer ">
                                <button
                                    onClick={() =>
                                        onLinkLink(
                                            "https://play.google.com/store/apps/details?id=com.daapapp.crmrn"
                                        )
                                    }
                                    className=" border-0 "
                                >
                                    <img
                                        src={Google_Play}
                                        loading="lazy"
                                        alt=""
                                        className="ms-1 "
                                    />
                                </button>
                                <button
                                    className="   border-0"
                                    onClick={() =>
                                        onLinkLink("https://cafebazaar.ir/app/com.daapapp.crmrn")
                                    }
                                >
                                    <img src={bazar} loading="lazy" alt="" className="ms-1"/>
                                </button>

                                <button
                                    onClick={() =>
                                        onLinkLink("https://myket.ir/app/com.daapapp.crmrn")
                                    }
                                    className=" border-0"
                                >
                                    <img src={myket} loading="lazy" alt="" className="ms-1"/>
                                </button>
                            </div>
                            <div className="down-link-app-fooer">

                                {/*<button*/}
                                {/*    onClick={() =>*/}
                                {/*        onLinkLink(*/}
                                {/*            "https://sibapp.com/applications/APPLICATION_GACCBBEF"*/}
                                {/*        )*/}
                                {/*    }*/}
                                {/*    className=" border-0"*/}
                                {/*>*/}
                                {/*    <img src={sibapp} loading="lazy" alt="" className="  ms-1 "/>*/}
                                {/*</button>*/}
                                <button
                                    onClick={() => onLinkLink("http://web-customer.daapapp.com/")}
                                    className=" border-0"
                                >
                                    <img src={webapp} loading="lazy" alt="" className="ms-1 "/>
                                </button>
                                <button
                                    className=" border-0 "
                                    onClick={() =>
                                        onLinkLink("https://anardoni.com/ios/app/nc2PaLAyW?lng=fa")
                                    }
                                >
                                    <img src={anardooni} loading="lazy" alt="" className="ms-1 "/>
                                </button>
                            </div>
                            {/* line 3 */}
                            {/*<div className=" down-link-app-fooer justify-content-start w-100 my-0">*/}
                            {/*    <button*/}
                            {/*        onClick={() =>*/}
                            {/*            onLinkLink(*/}
                            {/*                "https://sibirani.com/apps/%D8%AF%D8%A7%D9%BE-%D8%A7-%D9%BE/"*/}
                            {/*            )*/}
                            {/*        }*/}
                            {/*        className=" bg-transparent border-0  me-1 ms-1"*/}
                            {/*    >*/}
                            {/*        <img*/}
                            {/*            src={sibirani}*/}
                            {/*            loading="lazy"*/}
                            {/*            alt=""*/}
                            {/*            className="  ms-0 w-100 "*/}
                            {/*        />*/}
                            {/*    </button>*/}
                            {/*    <button*/}
                            {/*        onClick={() =>*/}
                            {/*            onLinkLink(*/}
                            {/*                "https://iapps.ir/app/%D8%AF%D8%A7%D9%BE-%D8%A7%D9%BE-daapapp/218159182"*/}
                            {/*            )*/}
                            {/*        }*/}
                            {/*        className=" border-0 ms-1"*/}
                            {/*    >*/}
                            {/*        <img*/}
                            {/*            src={Iapps}*/}
                            {/*            loading="lazy"*/}
                            {/*            alt=""*/}
                            {/*            className="ms-1  w-100"*/}
                            {/*        />*/}
                            {/*    </button>*/}
                            {/*    <button*/}
                            {/*        onClick={() =>*/}
                            {/*            onLinkLink(*/}
                            {/*                "https://sibche.com/applications/%D8%AF%D8%A7%D9%BE-%D8%A7-%D9%BE"*/}
                            {/*            )*/}
                            {/*        }*/}
                            {/*        className=" border-0"*/}
                            {/*    >*/}
                            {/*        <img src={sibche} loading="lazy" alt="" className="  w-100"/>*/}
                            {/*    </button>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>

                <div className="daapapp-details container p-0 py-5">
                    <div className="footer-details-logo ps-2">
                        <div className="logo-footer ms-3">
                            <img src={logo} alt="" className=" h-50"/>
                            <img src={dapapptext} alt="" className="mt-2"/>
                        </div>
                        <div className="addres-compani ps -5">
                            <h6>درباره داپ‌اَپ</h6>
                            <p>
                                شرکت دانش بنیان درنیکا اندیشه پرهام در تیرماه سال ۱۳۹۸ تأسیس شده و
                                برای نخستین بار در ایران، پلتفرم پاداش نقدی خرید با نام تجاری
                                “داپ‌اَپ” را با مشارکت نظام بانکی کشور طراحی و راه اندازی کرده است
                            </p>
                            <p>
                                <GeoAlt size={25} className="ms-2 mb-1"/>
                                آدرس: <br/> تهران، خیابان ولیعصر، بالاتر از تقاطع فاطمی، کوچه
                                شهید حمیدرضا افتخاری نیا، پلاک ۵۲
                            </p>
                            <div className="phone-number-daapapp d-flex ">
                                <p>
                                    <Telephone size={23} className="ms-2 mb-1"/>
                                    تلفن پشتیبانی:
                                    <br/>
                                    <span className="ps-2 pt-2">۰۲۱-۸۸۸۹۳۲۱۷</span> |
                                    <span className="ps-2 mt-5">۰۹۰۱-۳۵۶۸۶۵۷</span>
                                </p>
                                <p className="  me-xl-4">
                                    <Telephone size={23} className="ms-2 mb-1"/>
                                    تلفن دفتر مرکزی:
                                    <br/>
                                    <span className="ps-2 pt-2">۰۲۱-۸۸۸۹۳۵۸۸ </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* NAMAD */}
                    <div className="footer-symbols">
                        <button
                            onClick={() => onLinkLink("http://ircreative.isti.ir/")}
                            className=" border-0 "
                        >
                            <img src={namad1} width={100} loading="lazy" alt="" className="me-0 "/>
                        </button>

                        {/* <a
            referrerpolicy="origin"
            target="_blank"
            href="https://trustseal.enamad.ir/?id=133448&amp;Code=lERxbVEtxWegtgR1dZYL"
          >
            <img referrerpolicy="origin" src={namad2} alt="" />
          </a> */}
                        <a
                            referrerpolicy="origin"
                            target="_blank"
                            href="https://trustseal.enamad.ir/?id=133448&amp;Code=lERxbVEtxWegtgR1dZYL"
                        >
                            <img
                                referrerpolicy="origin"
                                width={100}
                                src={namad2}
                                alt=""
                                // style="cursor:pointer"
                                id="lERxbVEtxWegtgR1dZYL"
                            />
                        </a>
                        <button
                            onClick={() => setEcunion(true)}
                            className="border-0"
                        >
                            <img src={ecunionIcon} style={{background: "white", outline: "1px solid #e4e7f0",width:"97px"}}
                              width={100} loading="lazy" alt="" className="me-0"/>
                        </button>
                    </div>
                </div>
                <div className="end-footer p-4 text-white">
                    تمام حقوق مادی و معنوی این سایت متعلق به شرکت درنیکا اندیشه پرهام می
                    باشد
                </div>
            </div>
            {
                ecunion &&
                <Modal
                    show={true}
                    size="lg"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                >
                    <Modal.Header className="">
                        <Modal.Title
                            id="contained-modal-title-vcenter"
                            className=" d-flex justify-content-between align-items-center w-100">
                            <h5 className="text-center flex-grow-1">اتحادیه صنف کسب وکارهای مجازی کشوری</h5>
                            <X
                                size={30}
                                onClick={() => setEcunion(false)}
                                className=" carousel-control-next-icon"
                            />
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <img className="w-100 h-100" src={ecunionImg}/>
                    </Modal.Body>
                </Modal>
            }
        </>
    );
};

export default FooterB;
